import { motion } from 'framer-motion';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { SESSIONS } from './data';

const scUrl = (track) =>
  `https://w.soundcloud.com/player/?url=${encodeURIComponent(
    track
  )}&color=%23d4ff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true`;

export const Sessions = () => (
  <section id="sesiones" data-testid="sessions-section" className="relative py-20 sm:py-32 border-t border-white/10 overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <img
        src="https://customer-assets.emergentagent.com/job_dj-alfredj/artifacts/sdfo9vqi_alfredj5.webp"
        alt=""
        aria-hidden
        className="w-full h-full object-cover opacity-[0.12] saturate-[0.6]"
      />
      <div className="absolute inset-0 bg-ink/80" />
    </div>
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12"
      >
        <p className="text-acid uppercase tracking-[0.3em] text-xs mb-4">La prueba de audio</p>
        <h2 className="font-heading uppercase text-4xl sm:text-6xl tracking-tight text-[#f1f0ea]">
          Escucha cómo suena una <span className="text-acid">sesión</span>
        </h2>
        <p className="mt-5 text-[#f1f0ea]/70 font-light max-w-2xl">
          Mixtapes temáticos para que compruebes el criterio antes de contratar. Dale al play.
        </p>
      </motion.div>

      <Tabs defaultValue={SESSIONS[0].id} className="w-full">
        <TabsList
          data-testid="sessions-tabs"
          className="flex flex-wrap h-auto bg-transparent p-0 gap-3 justify-start mb-8"
        >
          {SESSIONS.map((s) => (
            <TabsTrigger
              key={s.id}
              value={s.id}
              data-testid={`session-tab-${s.id}`}
              className="rounded-none border border-white/15 bg-transparent px-5 py-3 font-heading uppercase text-sm sm:text-base text-[#f1f0ea]/70 data-[state=active]:bg-acid data-[state=active]:text-white data-[state=active]:shadow-none transition-colors"
            >
              {s.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {SESSIONS.map((s) => (
          <TabsContent key={s.id} value={s.id} data-testid={`session-content-${s.id}`}>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
              <div className="lg:col-span-1">
                <h3 className="font-heading uppercase text-3xl text-[#f1f0ea]">{s.title}</h3>
                <p className="mt-4 text-[#f1f0ea]/70 font-light">{s.desc}</p>
              </div>
              <div className="lg:col-span-2 border border-white/10 bg-surface p-2">
                <iframe
                  title={s.title}
                  width="100%"
                  height="320"
                  scrolling="no"
                  frameBorder="no"
                  allow="autoplay"
                  loading="lazy"
                  src={scUrl(s.url)}
                />
              </div>
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  </section>
);
